import keys from 'lodash/keys'
import toPairs from 'lodash/toPairs'

export default class QueryString {
  static stringify(hash, encode) {
    if (!hash || !keys(hash).length) { return '' }
    const hashKeys = keys(hash)
    return hashKeys.map((prop) => {
      const key = encode ? encodeURIComponent(prop) : prop
      const value = encode ? encodeURIComponent(hash[prop]) : hash[prop]
      return `${key}=${value}`
    }).join('&')
  }

  static searchParams(hash) {
    // wrapper of URLSearchParams to generate url form encoded or query string
    const params = new URLSearchParams()
    toPairs(hash).forEach(([key, value]) => {
      params.append(key, value)
    })
    return params.toString()
  }

  static parse(string) {
    if (!string) { return {} }

    let stringToBeParsed = string
    if (stringToBeParsed.indexOf('?') === 0) {
      stringToBeParsed = stringToBeParsed.slice(1)
    }
    const hash = {}
    const params = stringToBeParsed.split(/&/g)
    params.forEach((param) => {
      const split = param.split('=')
      const key = split[0]
      const value = split[1]
      hash[key] = decodeURIComponent(value)
    })
    return hash
  }
}



// WEBPACK FOOTER //
// ./shared/util/string/query-string.js